export default __webpack_public_path__ + "static/english-cover-a086957c6eaaf52552d9dd5a44cf5c21.jpg";